import { ReactElement, useEffect } from 'react';
import { useLocation } from "react-router-dom";

// common
// component
import { IntroSection } from "./components/IntroSection";
import { ServicesSection } from "../services/ServicesSection";
import { AbilitySection } from "../ability/AbilitySection";
import { WorksSection } from "../works/WorksSection";
import { PartnerSection } from "./components/PartnerSection";
import { scrollTo, scrollToQuery } from "@util/scroll-tools";


const HomePage = (): ReactElement => {
  const location = useLocation();

  useEffect(() => {
    if (location.state?.archor) {
      scrollToQuery("#main-content", location.state.archor)
    }
  }, [location.state?.archor]);

  return (
    <>
      <IntroSection />
      <ServicesSection />
      <WorksSection />
      <AbilitySection />
      <PartnerSection />
    </>
  );
};

export default HomePage;
